"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /**
 * 立减活动管理路由
 * 单独配置，不影响原有营销模块
 */
var instantDiscountRouter = {
  path: '/marketing/instantDiscount',
  component: _layout.default,
  redirect: '/marketing/instantDiscount/list',
  name: 'InstantDiscount',
  meta: {
    title: '立减活动管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    name: 'InstantDiscountList',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/marketing/instantDiscount/index'));
      });
    },
    meta: {
      title: '立减活动列表',
      icon: ''
    }
  }
  // 路由会动态加载弹窗组件，无需在此配置
  ]
};
var _default = exports.default = instantDiscountRouter;